var vsprintf = require('sprintf-js').vsprintf;

var QueryString = require('../util/QueryString');
var Config = require('../config/Config');
var OAuth = require('../util/OAuth');
var TokenStore = require('../stores/TokenStore');
var UserActions = require('./UserActions');
var UserStore = require('../stores/UserStore');

var AuthenticationActions = {
    /**
     * Check if the user has an oauth token. If not, redirect to the SSO server.
     *
     * @param returnQuery (optional) Extra query string params for the *return* trip.
     */
    authenticate: function (returnQuery) {
        this.logout();
        var token = OAuth.getOAuthToken();
        var qs = QueryString.parse(document.location.hash.substr(1));

        if (!token) {
            var router = require('../router');
            // Yay for IE!
            var redirectTo = vsprintf('%s//%s%s%s', [
                window.location.protocol,
                window.location.hostname,
                window.location.port ? ':' + window.location.port : '',
                router.makePath('login', {}, returnQuery)
            ]);

            window.location.href = vsprintf(Config.ssoAuthenticationUrl, [encodeURIComponent(redirectTo)]);

            return;
        }

        if (qs.inf_client_id) {
            UserStore.setActiveClientId(parseInt(qs.inf_client_id, 10));
        }

        TokenStore.setToken(token);
        UserActions.getUser(token);
    },
    /**
     * Wipes local storage..
     */
    logout: function () {
        TokenStore.setToken(null);
        UserStore.logout();
    }
};
module.exports = AuthenticationActions;



// WEBPACK FOOTER //
// ./app/actions/AuthenticationActions.js